export default class kvManager{
    constructor(pageID,param){

        this.header = document.getElementById('l-header');
        this.headerList = document.querySelectorAll('#l-header__list>li');

        if(document.getElementById('p-kv__scroll')){
            this.scrollEl = document.getElementById('p-kv__scroll');
            this.scrollArrow = this.scrollEl.querySelector('.arrow');
        }

        if(document.getElementById('l-lowlayer__body')) {
            this.body = document.getElementById('l-lowlayer__body');
        }

        switch(pageID) {
            case "top":
                this.copy = document.getElementById('p-kv__copy');
                this.bg = document.getElementById('p-kv__bg');
                this.max = 5;
                break;
            case "oven_pot_round":
                this.title = document.getElementById('p-kv__text-title');
                this.copyPC = document.querySelectorAll('#p-kv__text-copy .pc>*');
                this.copySP = document.querySelectorAll('#p-kv__text-copy .sp>*');
                this.bg = document.getElementById('p-kv__bg');
                this.max = false;
                break;
            case "kitchenitems":
                this.copy = document.getElementById('p-kv__copy');
                this.bg = document.getElementById('p-kv__bg');
                this.max = false;
                break;
            case "magnettrivet":
            case "hk_and_ph":
            case "apron_and_cloth":
            case "food":
                this.copy = document.getElementById('p-kv__copy__inner');
                this.bg = document.getElementById('p-kv__bg');
                this.text = document.getElementById('p-kv__text');
                break;
            case "ricepot":
                this.copy = document.getElementById('p-kv__copy');
                this.bg = document.getElementById('p-kv__bg');
                this.max = 6;
                break;
            case "new_color":
                this.copyTop = document.querySelector('#kv-content__inner .page_title .top');
                this.copyTopChildren;
                this.copyBottom = document.querySelector('#kv-content__inner .page_title .bottom img');
                this.bg = document.querySelector('#kv-content__inner .bg');
                break;
            case "about_technology":
                this.copy = document.getElementById('p-kv-fixed');
                this.slider = document.getElementById('p-kv-slider');
                break;
            default:
                if (document.getElementById('l-lowlayer__body')){
                    if (document.getElementById('p-kv__bg')) {
                        this.copy = document.getElementById('p-kv__copy');
                        this.bg = document.getElementById('p-kv__bg');
                    }else{
                        this.copy = document.getElementById('p-kv__copy');
                    }
                }
                break;
        }

        this.num = 1;

        /* ステータス */
        this.status = {
            device : ( window.innerWidth>param.breakpoint )?"pc":"sp",
        }

        this.param = param;
        this.pageID = pageID;

    }
    init() {

        if(this.scrollEl){
            TweenMax.set(this.scrollEl, {
                opacity: 0
            });
        }

        switch(this.pageID){
            case "top":
                TweenMax.set(this.copy.children, {
                    opacity: 0,
                });
                TweenMax.set(this.bg, {
                    display: 'none',
                    opacity: 0,
                });
                TweenMax.set(this.header, {
                    opacity: 0,
                    y: -100
                });
            break;
            case "oven_pot_round":
                TweenMax.set([this.title,this.copyPC,this.copySP], {
                    opacity: 0,
                });
                TweenMax.set(this.bg, {
                    display: 'none',
                    opacity: 0,
                });
            break;
            case "ricepot":
                TweenMax.set(this.copy.children, {
                    y: '120%',
                });
                TweenMax.set(this.bg, {
                    display: 'none',
                    opacity: 0,
                    scale:1.1,
                });
                break;
            case "new_color":
                TweenMax.set(this.bg, {scale: 1.05, opacity: 0});
                let text = new SplitText(this.copyTop, {type: "words,chars"}),
                    chars = text.chars;
                this.copyTopChildren = chars;
                TweenMax.set(this.copyTopChildren, {y: '120%'});
                TweenMax.set(this.copyBottom, {y: '22px'});
                TweenMax.set(this.bg, {
                    display: 'none',
                    opacity: 0,
                    scale:1.1,
                });
                TweenMax.set(this.header, {
                    opacity: 0,
                    y: -100
                });
                TweenMax.set(this.headerList, {
                    opacity: 0,
                    x: -300
                });
                break;
            case "mini":
                TweenMax.set("#p-kv .bg", {scale: 1.1, opacity: 0});
                TweenMax.set("#p-kv .page_title .bottom > *", {y: 40, opacity: 0});
                TweenMax.set("#p-kv .page_title .top", {y: '-40px',opacity: 0});
                TweenMax.set("#p-kv .page_title .bottom2", {y: '0',opacity: 0});
                TweenMax.set("#p-kv .page_title", {top: '50%', marginTop: '-90px'});
                TweenMax.set("#p-kv .kv_image01", {y: '20px',opacity: 0});
                TweenMax.set("#p-kv .kv_image02", {y: '20px'});
                TweenMax.set("#p-kv .kv_image03", {y: '20px'});
                TweenMax.set(this.header, {
                    opacity: 0,
                    y: -100
                });
                TweenMax.set(this.headerList, {
                    opacity: 0,
                    x: -300
                });
                break;
            case "kitchenitems":
                TweenMax.set(this.copy.children, {
                    y: '120%',
                });
                TweenMax.set(this.bg, {
                    display: 'none',
                    opacity: 0,
                    scale:1.1,
                });
                TweenMax.set(this.header, {
                    opacity: 0,
                    y: -100
                });
                break;
            case "magnettrivet":
            case "hk_and_ph":
            case "apron_and_cloth":
            case "food":
                TweenMax.set(this.bg, {
                    scale:1.2,
                    opacity:0,
                });
                TweenMax.set(this.copy.children, {
                    y:'50px',
                });
                TweenMax.set(this.text, {
                    opacity:0,
                    y:30,
                });
                TweenMax.set(this.header, {
                    opacity: 0,
                    y: -100
                });
                break;
            case "about_technology":
                TweenMax.set([this.copy,this.slider], {
                    opacity:0
                });
                TweenMax.set(this.header, {
                    opacity: 0,
                    y: -100
                });
                TweenMax.set(this.body, {
                    opacity:0,
                });
                break;
            case "fryingpan_care":
            case "fryingpan_concept":
            case "fryingpan_features":
            case "fryingpan_madeinjapan":
            case "fryingpan_spec":
            case "fryingpan_technology":
                TweenMax.set(this.header, {
                    opacity: 0,
                    y: -100
                });
                break;
            default:
                if (document.getElementById('l-lowlayer__body')) {
                    if (document.getElementById('p-kv__bg')) {
                        TweenMax.set(this.bg, {
                            opacity: 0,
                        });
                        TweenMax.set(this.copy.children, {
                            opacity: 0
                        });
                        TweenMax.set(this.header, {
                            opacity: 0,
                            y: -100
                        });
                        TweenMax.set(this.body, {
                            opacity: 0,
                        });
                    }else{
                        TweenMax.set(this.copy.children, {
                            opacity: 0
                        });
                        TweenMax.set(this.header, {
                            opacity: 0,
                            y: -100
                        });
                        TweenMax.set(this.body, {
                            opacity: 0,
                        });
                    }
                }
                break;
        }

        this.motion();

    }

    motion() {

        switch(this.pageID) {
            case "top":
            TweenMax.to(this.bg, 0.6, {
                opacity: 1,
                display: 'block',
                ease: Power1.easeOut,
                onComplete: () => {
                    TweenMax.to(this.copy.firstElementChild, 1.8, {
                        delay: 0.12,
                        opacity: 1,
                        ease: Power1.easeOut,
                        onComplete: () => {
                            TweenMax.to(this.header, .78, {
                                delay:1,
                                opacity: 1,
                                y: 0,
                                ease:Power4.easeOut,
                            });
                            this.scroll();
                            TweenMax.to(this.copy.lastElementChild, 1.8, {
                                delay: 0.12,
                                opacity: 1,
                                ease: Power1.easeOut,
                                onComplete: () => {
                                    this.slide();
                                }
                            });
                        }
                    });
                }
            });
            break;
            case "oven_pot_round":
                TweenMax.to(this.bg, 0.6, {
                    delay:1.2,
                    opacity: 1,
                    display: 'block',
                    ease: Power1.easeOut,
                    onComplete: () => {
                        TweenMax.to(this.title, 1.6, {
                            delay: 0.12,
                            opacity: 1,
                            ease: Power1.easeOut,
                            onComplete: () => {
                                if(this.param.displayType === 'pc'){
                                    TweenMax.staggerTo(this.copyPC, 1.8, {
                                        delay: 0.12,
                                        opacity: 1,
                                        ease: Power1.easeOut
                                    },1.6);
                                }else{
                                    TweenMax.staggerTo(this.copySP, 1.8, {
                                        delay: 0.12,
                                        opacity: 1,
                                        ease: Power1.easeOut
                                    },1.6);
                                }
                            }
                        });
                    }
                });
            break;
            case "ricepot":
                TweenMax.to(this.copy.children, 1.2, {
                    delay:1.2,
                    y: '0%',
                    ease:Power4.easeOut,
                    onComplete: () => {
                        TweenMax.set(this.copy, {
                            css: {'overflow': 'visible'}
                        });
                        this.scroll();
                    }
                });
                TweenMax.to(this.bg, 0.78, {
                    delay:2.05,
                    opacity: 1,
                    display: 'block',
                    scale:1,
                    ease:Power1.easeOut,
                    onComplete: () => {
                        setTimeout(() => {
                            this.slide();
                        },3e3);
                    }
                });
                break;
            case "new_color":
                TweenMax.staggerTo(this.copyTopChildren, .88, {
                    y: '0%', ease: Power2.easeOut,
                },.04);
                TweenMax.to(this.copyBottom, 0.78, {
                    delay: 0.88,
                    y: '0px',
                    ease: Power3.easeOut,
                        onStart: () => {
                            TweenMax.to(this.header, .78, {
                                opacity: 1,
                                y: 0,
                                ease:Power4.easeOut,
                            });
                            TweenMax.staggerTo(this.headerList, .78, {
                                delay:0.2,
                                opacity: 1,
                                x: 0,
                                ease:Power4.easeOut,
                            },0.12);
                        }
                    }
                );
                TweenMax.to(this.bg, 1.28, {
                    delay: 1.18,
                    scale: 1,
                    display:'block',
                    opacity: 1,
                    ease: Power3.easeOut,
                    onComplete: () => {
                        this.scroll();
                    }
                });

                TweenMax.to(this.copyTopChildren, 1.2, {
                    delay:1.2,
                    y: '0%',
                    ease:Power4.easeOut,
                    onComplete: () => {
                        this.scroll();
                        TweenMax.to(this.header, .78, {
                            opacity: 1,
                            y: 0,
                            ease:Power4.easeOut,
                        });
                        TweenMax.staggerTo(this.headerList, .78, {
                            delay:0.2,
                            opacity: 1,
                            x: 0,
                            ease:Power4.easeOut,
                        },0.12);
                    }
                });
                TweenMax.to(this.bg, 0.78, {
                    delay:2.05,
                    opacity: 1,
                    display: 'block',
                    scale:1,
                    ease:Power1.easeOut
                });
                break;
            case "mini":
                TweenMax.to("#p-kv .page_title .top", 0.78,{
                    delay:0.4,
                    opacity: 1,
                    y: '0px',
                    ease: Power3.easeOut,
                    onStart:()=>{
                        TweenMax.staggerTo("#p-kv .page_title .bottom>*", .88,{
                            delay: 0.40,
                            y: 0, opacity:1, ease: Power2.easeOut,
                        },.10);
                        TweenMax.to("#p-kv .page_title", .88,{
                            delay: 1.4,
                            top:'31%',marginTop: 0, ease: Power2.easeOut,
                        });
                        TweenMax.to("#p-kv .page_title .bottom2", .88,{
                            delay: 1.4,
                            opacity: 1,
                            y: '0px', ease: Power3.easeOut,
                        });
                        TweenMax.to("#p-kv .bg", 1.28, {
                            delay: 1.18, scale: 1, opacity: 1, ease: Power3.easeOut,
                            onComplete: () => {
                                this.scroll();
                                TweenMax.to(this.header, .78, {
                                    opacity: 1,
                                    y: 0,
                                    ease:Power4.easeOut,
                                });
                                TweenMax.staggerTo(this.headerList, .78, {
                                    delay:0.2,
                                    opacity: 1,
                                    x: 0,
                                    ease:Power4.easeOut,
                                },0.12);
                            }
                        });
                        TweenMax.to("#p-kv .kv_image02, #p-kv .kv_image03", 0.48,{
                            delay: 1.1,
                            y: '0px',
                            opacity: 1,
                            ease: Power3.easeOut
                        });
                        TweenMax.to("#p-kv .kv_image01", 0.48,{
                            delay: 1.58,
                            y: '0px',
                            opacity: 1,
                            ease: Power3.easeOut
                        });
                    }
                });
                break;
            case "kitchenitems":
                TweenMax.to(this.copy.children, 1.2, {
                    delay:1.2,
                    y: '0%',
                    ease:Power4.easeOut,
                    onComplete: () => {
                        TweenMax.set(this.copy, {
                            css: {'overflow': 'visible'}
                        });
                        TweenMax.to(this.header, .78, {
                            opacity: 1,
                            y: 0,
                            ease:Power4.easeOut,
                        });
                        this.scroll();
                    }
                });
                TweenMax.to(this.bg, 0.78, {
                    delay:2.05,
                    opacity: 1,
                    display: 'block',
                    scale:1,
                    ease:Power1.easeOut,
                });
                break;
            case "magnettrivet":
            case "hk_and_ph":
            case "apron_and_cloth":
            case "food":
                TweenMax.to(this.copy.children, 1.2 , {
                    delay:1.2,
                    y:'0px',
                    opacity:1,
                    ease: Power4.easeIn,
                    onComplete : () => {
                        TweenMax.set(this.copy, {
                            css: {'overflow': 'visible'}
                        });
                    }
                });
                TweenMax.to(this.text, 1.2 , {
                    delay:1.8,
                    y:0,
                    opacity:1,
                    ease: Power4.easeInOut,
                });
                TweenMax.to(this.bg, 0.78 , {
                    delay:2.05,
                    scale:1,
                    opacity:1,
                    ease: Power1.easeOut,
                    onComplete:()=>{
                        TweenMax.to(this.header, .78, {
                            opacity: 1,
                            y: 0,
                            ease:Power4.easeOut,
                        });
                        this.scroll();
                    }
                });
                break;
            case "about_technology":
                TweenMax.to([this.copy,this.slider], .78, {
                    delay: 2,
                    opacity:1,
                    ease:Power2.easeOut,
                });
                TweenMax.to(this.header, .78, {
                    delay:0.5,
                    opacity: 1,
                    y: 0,
                    ease:Power2.easeOut,
                });
                TweenMax.to(this.body, .88, {
                    delay: 2,
                    opacity: 1,
                    ease:Power2.easeOut,
                });
                break;
            default:
                if (document.getElementById('l-lowlayer__body')) {
                    if (document.getElementById('p-kv__bg')) {
                        TweenMax.to(this.bg, 0.6, {
                            opacity: 1,
                            display: 'block',
                            ease: Power1.easeOut,
                            onComplete: () => {
                                let _delay = ( this.copy.children.length === 1 )?1.3:1.75;
                                TweenMax.staggerTo(this.copy.children, 1.18, {
                                    delay: 0.85,
                                    y: '0px',
                                    opacity: 1,
                                    ease: Power2.easeOut,
                                }, 0.5);
                                TweenMax.to(this.header, .78, {
                                    delay: 0.45,
                                    opacity: 1,
                                    y: 0,
                                    ease: Power2.easeOut,
                                });
                                TweenMax.to(this.body, 1.18, {
                                    delay: _delay,
                                    opacity: 1,
                                    ease: Power2.easeOut,
                                });
                            }
                        });
                    }else{
                        TweenMax.staggerTo(this.copy.children, 0.88, {
                            delay: 1,
                            y: '0px',
                            opacity: 1,
                            ease: Power2.easeOut,
                        }, 0.55);
                        TweenMax.to(this.header, .78, {
                            delay: 0.5,
                            opacity: 1,
                            y: 0,
                            ease: Power2.easeOut,
                        });
                        TweenMax.to(this.body, .88, {
                            delay: 2,
                            opacity: 1,
                            ease: Power2.easeOut,
                        });
                    }
                }
                break;
        }

    }

    slide() {

        if(this.num == this.max){
            this.num = 1;
        }else{
            this.num ++;
        }

        TweenMax.to(this.bg, 1.4 , {
            opacity: 0,
            ease: Power1.easeOut,
            onComplete:() => {
                this.bg.className = 'p-kv__bg'+this.num;
                TweenMax.to(this.bg, 1.4 , {
                    delay:0.2,
                    opacity: 1,
                    ease: Power1.easeOut,
                    onComplete:() => {
                        setTimeout(() => {
                            this.slide();
                        },4e3);
                    }
                });
            }
        });

    }

    scroll() {

        let _tl = new TimelineMax({
            repeat:-1
        });

        _tl.set(this.scrollArrow, {
            opacity: 0,
        });

        TweenMax.to(this.scrollEl, .6, {
            delay:1.6,
            opacity: 1,
            y:0,
            ease: Power1.easeOut,
            onComplete:() => {
                _tl.set(this.scrollArrow, {
                    y: -12,
                    opacity: 0
                }).to(this.scrollArrow,.4,{
                    y: 0,
                    opacity: 1,
                    ease: Power1.easeOut,
                }).to(this.scrollArrow,.6,{
                    delay:0.3,
                    opacity: 0,
                    y: 15,
                    ease: Power1.easeOut,
                });
            }
        });

    }

    set(type){

        switch(type) {
            case "pc":
                if(this.pageID === 'oven_pot_round'){
                    TweenMax.set(this.copyPC , {
                        opacity : 1,
                    });
                }
                break;
            case "sp":
                if(this.pageID === 'oven_pot_round'){
                    TweenMax.set(this.copySP , {
                        opacity : 1,
                    });
                }
                break;
        }

    }

    resize(_w){
        if(_w>this.param.breakpoint){
            if(this.status.device==="sp") this.set("pc");
            this.status.device = "pc";
        }else{
            if(this.status.device==="pc") this.set("sp");
            this.status.device = "sp";
        }
    }
}